import * as Yup from 'yup';

export const validationSchema = Yup.object({
    name: Yup.string().required('Site Name is required').max(200),
    description: Yup.string().max(1000),
    address: Yup.string().nullable(),
    pbx: Yup.string().nullable(),
});

export const SITE_COLUMNS = [
    {
        field: 'name',
        headerName: 'Site Name',
        flex: 2,
        minWidth: 200,
        sortable: true,
    },
    {
        field: 'platformReference',
        headerName: 'Platform Reference',
        flex: 1,
        minWidth: 180,
        sortable: true,
        cellRenderer: (params) => params.value || '—',
    },
    {
        field: 'description',
        headerName: 'Description',
        flex: 1.5,
        minWidth: 160,
        sortable: true,
        cellRenderer: (params) => params.value || '—',
    },
    {
        field: 'pbx',
        headerName: 'PBX',
        flex: 1,
        minWidth: 200,
        sortable: true,
        cellRenderer: (params) => params.value || '—',
    },
];
